export function Constants() {
  angular.module("classkickApp").constant("constants", {
    version: "5.295.1-719ceda",
    backend: "webservices",
    projectId: "classkick-907",
  })
}
